export class AccountTypeData {
    private accountTypeList: string[] = ['Margin', 'Cash', 'Portfolio Margin'];

    public getAccountTypeList(): Array<string> {
        return this.accountTypeList;
    }
}